import { render, staticRenderFns } from "./todo-app.html?vue&type=template&id=02dfdf97&scoped=true&"
import script from "./todo-app.js?vue&type=script&lang=js&"
export * from "./todo-app.js?vue&type=script&lang=js&"
import style0 from "./todo-app.scss?vue&type=style&index=0&id=02dfdf97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dfdf97",
  null
  
)

export default component.exports